import { useTranslation } from 'react-i18next';

export default function ResultsTimelineSection() {
  const { t } = useTranslation();

  const milestones = [
    {
      period: t('threeStep.timeline.m1.period'),
      title: t('threeStep.timeline.m1.title'),
      desc: t('threeStep.timeline.m1.desc'),
      color: '#1B3A5C',
    },
    {
      period: t('threeStep.timeline.m2.period'),
      title: t('threeStep.timeline.m2.title'),
      desc: t('threeStep.timeline.m2.desc'),
      color: '#7B1113',
    },
    {
      period: t('threeStep.timeline.m3.period'),
      title: t('threeStep.timeline.m3.title'),
      desc: t('threeStep.timeline.m3.desc'),
      color: '#2D6A4F',
    },
  ];

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center text-center gap-4 mb-12 md:mb-16">
          <div className="flex items-center gap-3">
            <div className="w-8 h-px bg-[#7B1113]" />
            <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">{t('threeStep.timeline.label')}</span>
            <div className="w-8 h-px bg-[#7B1113]" />
          </div>

          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-[1.15]">
            {t('threeStep.timeline.heading')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {milestones.map((m, i) => (
            <div key={m.period} className="relative flex flex-col gap-4 p-8 rounded-2xl bg-[#F0EFED]">
              {/* Connector line on desktop */}
              {i < 2 && (
                <div className="hidden md:block absolute top-12 -right-2.5 w-5 h-px bg-[#8A8A8A]/20" />
              )}

              <div className="flex items-center gap-3">
                <span
                  className="w-12 h-12 rounded-full flex items-center justify-center text-white text-sm font-bold"
                  style={{ backgroundColor: m.color }}
                >
                  {i + 1}
                </span>
                <span className="text-xs font-medium text-[#2A2A2A]">{m.period}</span>
              </div>

              <h3 className="font-serif text-lg font-semibold text-[#2A2A2A]">{m.title}</h3>
              <p className="text-xs text-[#8A8A8A] font-light leading-[1.7]">{m.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}